class quickview extends HTMLElement {
  constructor() {
    super();
    $(".ap-quickview-popup .close-popup").click(function () {
      $(".ap-quickview-popup").removeClass("show");
      $(".ap-quickview-popup").hide();
      $("body.gradient").removeClass("modal-open");
      $("body.gradient").css({ overflow: "auto", "padding-right": "0" });
    });
    this.addEventListener("click", (event) => {
      this.show(this);
    });
  }
  show(evt) {
    var url = "/products/" + this.getAttribute("data-handle");
    var _datahandle = this.getAttribute("data-handle");
    $.ajax({
      type: "GET",
      url: url + ".js",
      dataType: "json",
      beforeSend: function () {
        $(".qv-product-variants").html("");
        var ap_load_popup = new bootstrap.Modal(document.getElementById("ap-quickview-popup"), {
          keyboard: true,
        });
        $("#ap-quickview-popup .js-btn-wishlist").removeClass("active");
        $("#ap-quickview-popup .js-btn-compare").removeClass("active");
        $(".qv-quantity .quantity__input").val(1);
        ap_load_popup.show();
      },
      complete: function (data) {
        var product = JSON.parse(data["responseText"]);
        $("#ap-quickview-popup .product__title").html(product.title);
        $("#ap-quickview-popup .product__description").html(product.description);
        $("#qv-product-images").html("");
        $("#qv-product-images").attr("class", "");
        for (var i = 0; i < product.media.length; i++) {
          if (product.media[i]["media_type"] == "image") {
            $("#qv-product-images").append(
              '<div><img src="' +
                product.media[i]["src"] +
                '" alt="' +
                product["title"] +
                '"></div>'
            );
          }
        }
        if (product.variants.length) {
          $("#ap-quickview-popup .variant-id").val(product.variants[0]["id"]);
          $(".qv-product-price").html(
            Shopify.formatMoney(product.variants[0]["price"], theme.moneyFormat)
          );
          $(".qv-product-variants").html(
            '<p class="option-label">' + product.variants[0]["title"].replace("/", "|") + "</p>"
          );

          if (product.variants[0]["available"] == true) {
            $("#product-form-quickview .product-form__submit").removeAttr("disabled");
            $("#product-form-quickview .product-form__submit").html(
              $("#product-form-quickview .product-form__submit").data("addcartlabel")
            );
          } else {
            $("#product-form-quickview .product-form__submit").attr("disabled", "disabled");
            $("#product-form-quickview .product-form__submit").html(
              $("#product-form-quickview .product-form__submit").data("outofstock")
            );
          }

          $(".qv-product-variants .variants-item")
            .find("input")
            .each(function () {
              $(this).attr("id", $(this).attr("id") + "_");
            });
          $(".qv-product-variants .variants-item")
            .find("label")
            .each(function () {
              $(this).attr("for", $(this).attr("for") + "_");
            });
        }

        if ($(".qv-product-options").length) {
          $(".qv-product-options").html("");
          for (var i = 0; i < product.options.length; i++) {
            var str = "<div>";
            str += "<label>" + product.options[i]["name"] + "</label>";
            str += '<select class="qv-product-op-' + i + '">';
            for (var j = 0; j < product.options[i]["values"].length; j++) {
              str +=
                '<option value="' +
                product.options[i]["values"][j] +
                '">' +
                product.options[i]["values"][j] +
                "</option>";
            }
            str += "</select>";
            str += "</div>";
            $(".qv-product-options").append(str);
          }
        }

        $(".qv-product-tags").html("");
        for (var i = 0; i < product.tags.length; i++) {
          if (i == 0) {
            $(".qv-product-tags").append("<span>Tags:</span>");
          }
          if (product.tags.length > 1 && i > 0) {
            $(".qv-product-tags").append(", ");
          }
          $(".qv-product-tags").append(
            '<a href="/collections/all/' +
              product.tags[i] +
              '" class="link-product-tag"><strong>' +
              product.tags[i] +
              "</strong></a>"
          );
        }
        $("#ap-quickview-popup .js-btn-wishlist").attr("data-handle", _datahandle);
        $("#ap-quickview-popup .js-btn-compare").attr("data-handle", _datahandle);
        if ($.cookie("wishlist")) {
          var wishlist = $.cookie("wishlist").split(",");
          if (wishlist.indexOf(_datahandle) >= 0) {
            $("#ap-quickview-popup .js-btn-wishlist").addClass("active");
          }
        }
        if ($.cookie("compare")) {
          var compare = $.cookie("compare").split(",");
          if (compare.indexOf(_datahandle) >= 0) {
            $("#ap-quickview-popup .js-btn-compare").addClass("active");
          }
        }

        $("#ap-quickview-popup .view-product-quickview").find("a").attr("href", url);

        $("#qv-product-images").slick();
        $(".qv-product-options")
          .find("select")
          .change(function () {
            var arr_options = [];
            $(".qv-product-options")
              .find("select")
              .each(function () {
                arr_options.push($(this).val());
              });

            var title_variant = arr_options.join(" / ");
            for (var i = 0; i < product.variants.length; i++) {
              if (product.variants[i]["title"] == title_variant) {
                $("#product-form-quickview .variant-id").val(product.variants[i]["id"]);
                $(".qv-product-price").html(
                  Shopify.formatMoney(product.variants[i]["price"], theme.moneyFormat)
                );
                $(".qv-product-variants").html('<p class="option-label">' + title_variant + "</p>");
                if (product.variants[i]["available"] == true) {
                  $("#product-form-quickview .product-form__submit").removeAttr("disabled");
                  $("#product-form-quickview .product-form__submit").html(
                    $("#product-form-quickview .product-form__submit").data("addcartlabel")
                  );
                } else {
                  $("#product-form-quickview .product-form__submit").attr("disabled", "disabled");
                  $("#product-form-quickview .product-form__submit").html(
                    $("#product-form-quickview .product-form__submit").data("outofstock")
                  );
                }
              }
            }
          });

        // updateCurrencies();
        // document.querySelector('product-quickview').init();
      },
      error: function (xhr, text) {
        alert($.parseJSON(xhr.responseText).description);
      },
    });
  }

  init() {}
}
customElements.define("product-quickview", quickview);
